import WTF from './wtf.js';

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  // Populate using an object literal
  WTF.init({
    heading: [
      "Let's pitch a fucking",
      "What about a fucking"
    ],

    response: [
      "The client didn't like that one.",
      "Their budget is too fucking low.",
      "You're not thinking big enough."
    ],

    template: [
      "One hundred @first placed all around the fucking @second",
      "Giant swarm of @first for a @second activation"
    ],

    first: [
      "drones",
      "crates",
      "statues",
      "unboxings",
      "influencers",
      "quote cards",
      "graffiti murals",
      "cinemagraphs",
      "illustrations",
      "earned media opportunities",
      "branding initiatives",
      "3D Printings",
      "Custom T-Shirt Designs"
    ],

    second: [
      "moon",
      "desert",
      "ocean",
      "obstacle course",
      "Kings of Leon concert",
      "dineLA",
      "Hollywood Bowl",
      "Venice Boardwalk",
      "Comic-Con",
      "Sunset Blvd.",
      "LA Live",
      "360 Augmented Reality",
      "Bluegrass Festivals",
      "Los Angeles",
      "Los Feliz"
    ]
  });

  // Alternative methods (commented out):
  // Populate using a JSON file
  // WTF.init('sample.json');

  // Populate using a Google spreadsheet ID (you must publish it first!)
  // @see https://support.google.com/drive/answer/37579?hl=en
  // WTF.init('0AvG1Hx204EyydF9ub1M2cVJ3Z1VGdDhTSWg0ZV9LNGc');
});
